<div class="fh-modal" role="dialog" aria-modal="true" aria-labelledby="price-modal-title">
  <div class="fh-modal-backdrop" (click)="closed.emit()"></div>
  <div class="fh-modal-panel">
    <div class="fh-modal-head">
      <span class="line-tile" [ngClass]="tone"><i class="bi bi-currency-euro"></i></span>
      <div class="flex-grow-1 min-w-0">
        <div class="small text-muted-fh text-truncate">{{ service.name }} · {{ product.name }}</div>
        <h2 id="price-modal-title" class="h5 fw-semibold mb-0">
          {{ isEdit ? 'Prezzo ' + provinceLabel(price!.province) : 'Aggiungi prezzo' }}
        </h2>
        <div *ngIf="isEdit" class="small text-muted-fh">Prezzo #{{ price!.id }}</div>
      </div>
      <button type="button" class="icon-btn" (click)="closed.emit()" aria-label="Chiudi">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="fh-modal-body">
      <div *ngIf="!isEdit" class="segmented mb-4">
        <button type="button" [class.active]="mode === 'create'" (click)="setMode('create')">
          <i class="bi bi-plus-circle me-1"></i>Nuovo prezzo
        </button>
        <button type="button" [class.active]="mode === 'link'" (click)="setMode('link')">
          <i class="bi bi-link-45deg me-1"></i>Collega esistente
        </button>
      </div>

      <!-- Nuovo / modifica -->
      <form *ngIf="mode === 'create' || isEdit" [formGroup]="form" (ngSubmit)="submit()" class="row g-3">
        <div class="col-sm-5">
          <label class="form-label" for="prc-amount">Importo</label>
          <div class="input-group">
            <span class="input-group-text">€</span>
            <input id="prc-amount" type="number" min="0" step="0.5" class="form-control text-end" formControlName="amount" />
          </div>
          <span class="form-error" *ngIf="(form.get('amount')?.touched || formInvalid) && form.get('amount')?.invalid">
            Inserisci un importo valido
          </span>
        </div>
        <div class="col-sm-7">
          <label class="form-label" for="prc-stripe">Stripe ID</label>
          <input id="prc-stripe" class="form-control mono" formControlName="stripeID" placeholder="price_…" />
        </div>

        <div *ngIf="isEdit" class="col-sm-6">
          <label class="form-label" for="prc-province">Provincia</label>
          <select id="prc-province" class="form-select" formControlName="province">
            <option *ngFor="let p of provinces" [ngValue]="p.value">{{ p.label }}</option>
          </select>
        </div>

        <div *ngIf="!isEdit" class="col-12">
          <div class="d-flex align-items-baseline justify-content-between mb-2">
            <span class="form-label mb-0">Province</span>
            <button type="button" class="link-btn small" (click)="toggleAllProvinces()">
              {{ allProvinces ? 'Deseleziona tutte' : 'Seleziona tutte' }}
            </button>
          </div>
          <div class="d-flex flex-wrap gap-2">
            <button
              type="button"
              *ngFor="let p of provinces"
              class="province-pill"
              [class.on]="selectedProvinces.includes(p.value)"
              [attr.aria-pressed]="selectedProvinces.includes(p.value)"
              (click)="toggleProvince(p.value)"
            >
              <i *ngIf="selectedProvinces.includes(p.value)" class="bi bi-check-lg"></i>{{ p.label }}
            </button>
          </div>
          <span class="hint d-block mt-1">Viene creato un prezzo per ogni provincia, tutti con lo stesso importo.</span>
          <span class="form-error d-block" *ngIf="formInvalid && !selectedProvinces.length">Scegli almeno una provincia</span>
        </div>
      </form>

      <!-- Collega esistente -->
      <div *ngIf="mode === 'link' && !isEdit">
        <div class="row g-2 mb-3">
          <div class="col-12">
            <label class="form-label" for="product">Prodotto</label>
            <app-product-select (productSelected)="filterByProduct($event)"></app-product-select>
          </div>
          <div class="col-sm-7">
            <label class="form-label" for="prc-search-stripe">Stripe ID</label>
            <input id="prc-search-stripe" class="form-control mono" type="search" [formControl]="searchStripeID" placeholder="price_…" />
          </div>
          <div class="col-sm-5">
            <label class="form-label" for="prc-search-province">Provincia</label>
            <select id="prc-search-province" class="form-select" [formControl]="searchProvince">
              <option [ngValue]="null">Tutte</option>
              <option *ngFor="let p of provinces" [ngValue]="p.value">{{ p.label }}</option>
            </select>
          </div>
        </div>
        <div class="result-list">
          <button
            type="button"
            *ngFor="let item of results"
            class="result-item"
            [class.selected]="selected?.id === item.id"
            [disabled]="inThisProduct(item)"
            (click)="selected = item"
          >
            <span class="fw-semibold" style="min-width: 84px">{{ euro(item.amount) }}</span>
            <span class="flex-grow-1 min-w-0">
              <span class="d-block small text-truncate">{{ provinceLabel(item.province) }} · <span class="mono">{{ item.stripeID || '—' }}</span></span>
              <span class="d-block small text-muted-fh text-truncate">#{{ item.id }} · {{ item.product ? item.product.name : 'nessun prodotto' }}</span>
            </span>
            <span *ngIf="inThisProduct(item)" class="chip chip-success">Già qui</span>
            <i *ngIf="selected?.id === item.id" class="bi bi-check-circle-fill text-primary"></i>
          </button>
          <div *ngIf="!searching && !results.length" class="text-center text-muted-fh small py-4">
            Nessun prezzo trovato.
          </div>
        </div>
        <div *ngIf="selected?.product && !inThisProduct(selected!)" class="notice mt-3">
          <i class="bi bi-exclamation-triangle me-1"></i>
          Un prezzo appartiene a un solo prodotto: verrà spostato da <b>{{ selected!.product.name }}</b> a {{ product.name }}.
        </div>
      </div>

      <div *ngIf="confirmDelete" class="notice mt-3">
        <i class="bi bi-exclamation-triangle me-1"></i>
        Il prezzo di {{ provinceLabel(price!.province) }} verrà eliminato. Premi «Conferma eliminazione» per procedere.
      </div>
      <div *ngIf="errorText" class="alert alert-danger small mt-3 mb-0">{{ errorText }}</div>
    </div>

    <div class="fh-modal-foot">
      <button *ngIf="isEdit" type="button" class="danger-link" [disabled]="saving" (click)="deletePrice()">
        <i class="bi bi-trash3 me-1"></i>{{ confirmDelete ? 'Conferma eliminazione' : 'Elimina' }}
      </button>
      <span *ngIf="!isEdit" class="hint">Importi in euro, salvati in centesimi.</span>
      <div class="d-flex gap-2">
        <button type="button" class="btn btn-light" (click)="closed.emit()">Annulla</button>
        <button type="button" class="btn btn-primary text-light" [disabled]="saving" (click)="submit()">
          <span *ngIf="saving" class="spinner-border spinner-border-sm me-1"></span>
          {{ isEdit ? 'Salva' : mode === 'link' ? 'Collega' : 'Crea prezzo' }}
        </button>
      </div>
    </div>
  </div>
</div>
